import { Money, toMoney } from '@betterment/js-runtime';
import { withScalars } from 'apollo-link-scalars';
import { parseISO } from 'date-fns';
import { IntrospectionQuery, buildClientSchema } from 'graphql';

import { data as schemaData } from '../../../../graphql/schema.json';

export const scalarsLink = withScalars({
  schema: buildClientSchema(schemaData as unknown as IntrospectionQuery),
  typesMap: {
    Cents: {
      serialize: (parsed: unknown): number | null => {
        if (parsed === null) return null;
        return (parsed as Money).cents;
      },
      parseValue: (raw: unknown): Money | null => {
        if (raw === null) return null;
        if (typeof raw === 'number') return toMoney(raw);
        throw new Error('parseValue Cents expected to parse a number');
      },
    },
    Date: {
      serialize: (parsed: unknown) => parsed,
      parseValue: (raw: unknown): Date | null => {
        if (raw === null) return null;
        if (typeof raw === 'string') return parseISO(raw);
        throw new Error('parseValue Date expected to parse an ISO8601 Date string');
      },
    },
  },
});
